// Función para formatear precio en soles peruanos
function formatToSoles(amount) {
  const price = (amount / 100).toFixed(2);
  return `S/ ${price}`;
}

// Función para actualizar todos los elementos de precio del header
function updateAllHeaderPrices(cartData) {
  const headerPriceElements = document.querySelectorAll('.header-cart-total');
  
  if (headerPriceElements.length > 0) {
    const formattedPrice = formatToSoles(cartData.total_price);
    
    headerPriceElements.forEach((element) => {
      element.textContent = formattedPrice;
      element.setAttribute('data-price', cartData.total_price);
    });
    
    return true;
  }
  return false;
}

// Función para obtener y actualizar el carrito
function fetchAndUpdateCart() {
  return fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      updateAllHeaderPrices(cart);
      return cart;
    })
    .catch(() => {
      // Manejo silencioso de errores
    });
}

// Variable para almacenar el último total conocido
let lastKnownTotal = 0;
let lastKnownItemCount = 0;

// Función para verificar si el carrito cambió
function checkCartChanges() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const currentTotal = cart.total_price;
      const currentItemCount = cart.item_count;
      
      // Si el total o la cantidad de items cambió, actualizar
      if (currentTotal !== lastKnownTotal || currentItemCount !== lastKnownItemCount) {
        lastKnownTotal = currentTotal;
        lastKnownItemCount = currentItemCount;
        updateAllHeaderPrices(cart);
      }
    })
    .catch(() => {
      // Error silencioso
    });
}

// Función para actualizar con reintentos después de agregar al carrito
function forceUpdateAfterAddToCart() {
  const delays = [100, 400];
  
  delays.forEach(delay => {
    setTimeout(fetchAndUpdateCart, delay);
  });
}

function initDistTabs() {
  const sections = document.querySelectorAll('[data-dist-tabs]');

  sections.forEach(function(section) {
    const navBtns = section.querySelectorAll('.dist-tabs__nav-btn');
    const panels = section.querySelectorAll('.dist-tabs__panel');

    if (!navBtns.length || !panels.length) return;

    navBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        const targetId = btn.getAttribute('data-dist-tab');
        if (!targetId) return;

        navBtns.forEach(function(b) {
          b.classList.remove('dist-tabs__nav-btn--active');
          b.setAttribute('aria-selected', 'false');
        });

        panels.forEach(function(panel) {
          panel.classList.remove('dist-tabs__panel--active');
          panel.hidden = true;
        });

        btn.classList.add('dist-tabs__nav-btn--active');
        btn.setAttribute('aria-selected', 'true');

        const activePanel = section.querySelector('[data-dist-panel="' + targetId + '"]');
        if (activePanel) {
          activePanel.classList.add('dist-tabs__panel--active');
          activePanel.hidden = false;
        }
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initDistTabs();
  
  // Interceptar clicks en botones "Add to Cart"
  document.addEventListener('click', function(e) {
    const addToCartBtn = e.target.closest('[name="add"], .btn-add-to-cart, .add-to-cart, [data-add-to-cart], .product-form__cart-submit');
    
    if (addToCartBtn) {
      setTimeout(forceUpdateAfterAddToCart, 500);
    }
  });

  // Interceptar envío de formularios de producto
  document.addEventListener('submit', function(e) {
    const form = e.target;
    
    if (form.matches('[action*="/cart/add"], .product-form, .shopify-product-form')) {
      setTimeout(forceUpdateAfterAddToCart, 500);
    }
  });

  // Escuchar el evento MinimogEvents (tema actual)
  if (window.MinimogEvents && MinimogTheme.pubSubEvents) {
    window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, function() {
      setTimeout(fetchAndUpdateCart, 100);
    });
  }

  // Interceptar fetch requests a /cart/add
  const originalFetch = window.fetch;
  window.fetch = function() {
    const url = arguments[0];
    
    if (typeof url === 'string' && url.includes('/cart/add')) {
      return originalFetch.apply(this, arguments).then(response => {
        if (response.ok) {
          setTimeout(forceUpdateAfterAddToCart, 300);
        }
        return response;
      });
    }
    
    return originalFetch.apply(this, arguments);
  };

  // Interceptar XMLHttpRequests (para apps AJAX como upsells)
  const originalXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function() {
    this.addEventListener('load', function() {
      if (this.status === 200) {
        const url = this.responseURL || '';
        // Si la request parece ser relacionada al carrito, verificar cambios
        if (url.includes('/cart') || url.includes('add') || url.includes('update')) {
          setTimeout(checkCartChanges, 500);
        }
      }
    });
    return originalXHRSend.apply(this, arguments);
  };

  // Monitor continuo: Verificar cambios cada 2 segundos
  setInterval(checkCartChanges, 2000);

  // Actualización inicial al cargar la página
  fetchAndUpdateCart().then(cart => {
    if (cart) {
      lastKnownTotal = cart.total_price;
      lastKnownItemCount = cart.item_count;
    }
  });

  // Escuchar eventos personalizados de carrito
  ['cart:updated', 'cart:changed', 'cart:items-updated', 'ajaxCart:updated'].forEach(eventName => {
    document.addEventListener(eventName, function() {
      setTimeout(checkCartChanges, 100);
    });
  });

  // Detectar cuando se abre/cierra el cart drawer
  const drawerObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          // Si se agrega un drawer/modal del carrito, verificar cambios más frecuentemente
          if (node.classList && (
            node.classList.contains('cart-drawer') ||
            node.classList.contains('drawer') ||
            node.classList.contains('modal') ||
            node.querySelector && node.querySelector('.cart-drawer, .cart-items')
          )) {
            // Verificar más frecuentemente cuando el drawer está abierto
            const frequentCheck = setInterval(checkCartChanges, 1000);
            
            // Detener verificación frecuente después de 30 segundos
            setTimeout(() => clearInterval(frequentCheck), 30000);
          }
        }
      });
    });
  });

  drawerObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});








document.addEventListener('DOMContentLoaded', function() {
  // 1. Seleccionamos el elemento usando la clase que generamos dinámicamente
  const productosBtn = document.querySelector('.m-menu__item--productos > a');

  if (productosBtn) {
    productosBtn.addEventListener('click', function(event) {
      // 2. Prevenimos la redirección del enlace si es necesario
      event.preventDefault(); 

      // 3. Buscamos el contenedor 'li' de este enlace
      const parentLi = this.parentElement;

      // 4. Alternamos (toggle) la clase activa en el 'li'
      parentLi.classList.toggle('m-menu__item-active');
    });
  }
});








(function () {
  if (window.__mImagePopupInit) return;
  window.__mImagePopupInit = true;

  var lockCount = 0;

  function preventTouchMove(e) {
    if (!e.target.closest('.m-image-popup__dialog')) {
      e.preventDefault();
    }
  }

  function lockScroll() {
    lockCount += 1;
    if (lockCount > 1) return;
    document.documentElement.classList.add('m:overflow-hidden');
    document.body.classList.add('m:overflow-hidden');
    document.addEventListener('touchmove', preventTouchMove, { passive: false });
  }

  function unlockScroll() {
    if (lockCount === 0) return;
    lockCount -= 1;
    if (lockCount > 0) return;
    document.documentElement.classList.remove('m:overflow-hidden');
    document.body.classList.remove('m:overflow-hidden');
    document.removeEventListener('touchmove', preventTouchMove, { passive: false });
  }

  function openPopup(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.hidden = false;
    el.setAttribute('aria-hidden', 'false');
    lockScroll();
  }

  function closeAll() {
    var opened = document.querySelectorAll('.m-image-popup:not([hidden])');
    if (!opened.length) return;
    opened.forEach(function (d) {
      d.hidden = true;
      d.setAttribute('aria-hidden', 'true');
    });
    unlockScroll();
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-popup-open]');
    if (openBtn) {
      e.preventDefault();
      openPopup(openBtn.getAttribute('data-popup-open'));
      return;
    }
    if (e.target.closest('[data-popup-close]')) {
      e.preventDefault();
      closeAll();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });
})();




document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (event) => {
    
    // 1. LÓGICA PARA ABRIR (Ahora evalúa el botón de la fila 1 Y de la fila 3)
    const isRow1Button = event.target.closest('.boards-row1__block .m-richtext__button a');
    const isRow3Button = event.target.closest('.boards-row3__block .m-richtext__button a');

    if (isRow1Button || isRow3Button) {
      event.preventDefault();
      const popupForm = document.querySelector('.popup-form-1');
      if (popupForm) {
        popupForm.style.display = 'flex';
      }
      return; // Detenemos la ejecución si se abrió el popup
    }

    // 2. LÓGICA PARA CERRAR (Al hacer clic en el fondo oscuro)
    if (event.target.matches('.popup-form-1')) {
      event.target.style.display = 'none';
    }
  });
});













(function() {
  let intentos = 0;
  const maxIntentos = 20;

  const esperarApp = setInterval(() => {
    intentos++;
    
    if (window.lbDealeasy && typeof window.lbDealeasy.getStoreSetup === 'function') {
      clearInterval(esperarApp);
      
      try {
        const setup = window.lbDealeasy.getStoreSetup();
        // Recogemos ambos tipos de ofertas disponibles
        const descuentos = setup?.offers?.discounts || [];
        const bogos = setup?.offers?.bogo || [];
        const todasLasPromos = [...descuentos, ...bogos];
        
        if (todasLasPromos.length > 0) {
          console.log("🚀 [Dev.js] Conexión establecida. Procesando descuentos y BOGOs...");
          procesarPromocionesDealeasy(todasLasPromos);
        }
      } catch (error) {
        console.error("[Dev.js] Error al procesar el setup:", error);
      }
    } else if (intentos >= maxIntentos) {
      clearInterval(esperarApp);
    }
  }, 500);
})();

function procesarPromocionesDealeasy(promociones) {
  promociones.forEach(promo => {
    // Validamos que tenga productos asignados
    const ids = promo.selectedProductIds || promo.productIds || [];
    if (ids.length > 0) {
      const productId = ids[0].split('/').pop(); 
      
      if (promo.tiers && promo.tiers.length > 0) {
        // Construimos el texto dinámicamente según el tipo de oferta
        const textoEtiqueta = promo.tiers.map(tier => {
          // Si tiene datos de BOGO (Pay/Get)
          if ((tier.payQuantity || tier.payQty) && (tier.freeQuantity || tier.freeQty)) {
            const pay = tier.payQuantity || tier.payQty;
            const get = tier.freeQuantity || tier.freeQty;
            return `Paga ${pay} y lleva ${get} GRATIS`;
          } 
          // Si es el descuento tradicional por volumen
          else {
            const cantidad = tier.quantity || tier.minQty || 0;
            const desc = tier.discount || tier.value || 0;
            return `${cantidad} uds: -${desc}%`;
          }
        }).join(' | ');

        console.log(`🎯 [Dev.js] Regla detectada para ID ${productId}: "${textoEtiqueta}"`);
        inyectarEtiquetaEnTienda(productId, textoEtiqueta);
      }
    }
  });
}

function inyectarEtiquetaEnTienda(productId, texto) {
  const tarjetaProducto = document.querySelector(`[data-product-id="${productId}"], .product-card-${productId}`);
  
  if (tarjetaProducto) {
    let etiquetaCustom = tarjetaProducto.querySelector('.dealeasy-custom-badge');
    if (!etiquetaCustom) {
      etiquetaCustom = document.createElement('div');
      etiquetaCustom.className = 'dealeasy-custom-badge';
      etiquetaCustom.style.cssText = "background-color: #e3f2fd; color: #0d47a1; padding: 6px; font-size: 11px; font-weight: bold; text-align: center; margin-bottom: 8px; margin-top: 5px; border-radius: 4px; border: 1px dashed #0d47a1; width: 100%; box-sizing: border-box;";
    }
    etiquetaCustom.innerText = texto;

    const bloqueCompra = tarjetaProducto.querySelector('form[action*="/cart/add"], .quick-add, button[name="add"], .btn');
    if (bloqueCompra && bloqueCompra.parentNode) {
      bloqueCompra.parentNode.insertBefore(etiquetaCustom, bloqueCompra);
    } else {
      tarjetaProducto.appendChild(etiquetaCustom);
    }
  }
}










